<template>
  <div>
    <Header ref="child" />
    <Navigation :page="page" />
    <div class="frailty-risk-body">
      <!-- ページ１ -->
      <div class="basic-data-page1 page-height" v-if="page === 1">
        <div>
          <p class="text-style">
            今月の<br />
            <span class="turquoise-blue">基本データ・健康度チェック</span><br />を入力しましょう。
          </p>
        </div>
        <div class="question-group">
          <div class="form-group">
            <label>体重</label>
            <br />
            <select v-model="hearings.weight">
              <option v-for="n in 100" :key="n" :value="n">{{ n }}</option>
            </select>
            <span>.</span>
            <select class="decimalPoint" v-model="decimalPoint">
              <option v-for="n in 10" :key="n" :value="n">{{ n - 1 }}</option>
            </select>
            <span class="unit">Kg</span>
          </div>
          <div class="form-group">
            <label>身長</label>
            <br />
            <select v-model="hearings.height">
              <option v-for="n in 200" :key="n" :value="n">{{ n }}</option> </select
            ><span class="unit">cm</span>
          </div>
          <div class="form-group">
            <label>屈伸回数</label><span class="warning">※10秒間のうち</span>
            <br />
            <select v-model="hearings.stretch">
              <option v-for="n in 16" :key="n" :value="n">{{ n - 1 }}</option> </select
            ><span class="unit">回</span><br />
            <label class="error-text">※無理のない範囲で行ってください</label>
          </div>
        </div>
      </div>

      <!-- ページ2 -->
      <div class="basic-data-page2 page-height" v-if="page === 2">
        <div :id="index" v-for="(item, index) in hearings.hearing_check" :key="item.content">
          <div class="question-group button-style" v-if="item.Number === 0">
            <p class="text-style" v-html="item.content.replace(/　/g, '<br/>').replace(/@/g, '<span class=gray-text>')"></p>
            <label><input type="radio" v-bind:value="yes" v-model="hearingId[item.id]" /><span>はい</span></label>
            <label><input type="radio" v-bind:value="no" v-model="hearingId[item.id]" /><span>いいえ</span></label>
          </div>
        </div>
      </div>

      <!-- ページ3 -->
      <div class="basic-data-page2 page-height" v-if="page === 3">
        <div :id="index" v-for="(item, index) in hearings.hearing_check" :key="item.content">
          <div class="question-group button-style" v-if="item.Number === 1">
            <p class="text-style" v-html="item.content.replace(/　/g, '<br/>').replace(/@/g, '<span class=gray-text>')"></p>
            <label><input type="radio" v-bind:value="yes" v-model="hearingId[item.id]" /><span>はい</span></label>
            <label><input type="radio" v-bind:value="no" v-model="hearingId[item.id]" /><span>いいえ</span></label>
          </div>
        </div>
      </div>

      <!-- ページ4 -->
      <div class="basic-data-page2 page-height" v-if="page === 4">
        <div :id="index" v-for="(item, index) in hearings.hearing_check" :key="item.content">
          <div class="question-group button-style" v-if="item.Number === 2">
            <p class="text-style" v-html="item.content.replace(/　/g, '<br/>').replace(/@/g, '<span class=gray-text>')"></p>
            <label><input type="radio" v-bind:value="yes" v-model="hearingId[item.id]" /><span>はい</span></label>
            <label><input type="radio" v-bind:value="no" v-model="hearingId[item.id]" /><span>いいえ</span></label>
          </div>
        </div>
      </div>

      <!-- ページ5 -->
      <div class="basic-data-page2 page-height" v-if="page === 5">
        <div :id="index" v-for="(item, index) in hearings.hearing_check" :key="item.content">
          <div class="question-group button-style" v-if="item.Number === 3">
            <p class="text-style" v-html="item.content.replace(/　/g, '<br/>').replace(/@/g, '<span class=gray-text>')"></p>
            <label><input type="radio" v-bind:value="yes" v-model="hearingId[item.id]" /><span>はい</span></label>
            <label><input type="radio" v-bind:value="no" v-model="hearingId[item.id]" /><span>いいえ</span></label>
          </div>
        </div>
      </div>

      <!-- ページ6 -->
      <div class="basic-data-page2 page-height" v-if="page === 6">
        <div :id="index" v-for="(item, index) in hearings.hearing_check" :key="item.content">
          <div class="question-group button-style" v-if="item.Number === 4">
            <p class="text-style" v-html="item.content.replace(/　/g, '<br/>').replace(/@/g, '<span class=gray-text>')"></p>
            <label><input type="radio" v-bind:value="yes" v-model="hearingId[item.id]" /><span>はい</span></label>
            <label><input type="radio" v-bind:value="no" v-model="hearingId[item.id]" /><span>いいえ</span></label>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <router-link to="/other">
        <img src="@/assets/meal_history/アセット 20@2x.png" v-if="page === 1" />
      </router-link>
      <img src="@/assets/sign_up/アセット 4@2x.png" v-if="page > 1" @click="prev" />
      <img src="@/assets/sign_up/アセット 3@2x.png" v-if="page === 1 && this.hearings.stretch === false" class = "inactive_img" />
      <img src="@/assets/sign_up/アセット 3@2x.png" v-else-if="page === 1" @click="next" />
      <img src="@/assets/sign_up/アセット 3@2x.png" v-if="page === 2 && Object.keys(this.hearingId).length < 3" class = "inactive_img" />
      <img src="@/assets/sign_up/アセット 3@2x.png" v-else-if="page === 2" @click="next" />
      <img src="@/assets/sign_up/アセット 3@2x.png" v-if="page === 3 && Object.keys(this.hearingId).length < 6" class = "inactive_img" />
      <img src="@/assets/sign_up/アセット 3@2x.png" v-else-if="page === 3" @click="next" />
      <img src="@/assets/sign_up/アセット 3@2x.png" v-if="page === 4 && Object.keys(this.hearingId).length < 9" class = "inactive_img" />
      <img src="@/assets/sign_up/アセット 3@2x.png" v-else-if="page === 4" @click="next" />
      <img src="@/assets/sign_up/アセット 3@2x.png" v-if="page === 5 && Object.keys(this.hearingId).length < 12" class = "inactive_img" />
      <img src="@/assets/sign_up/アセット 3@2x.png" v-else-if="page === 5" @click="next" />
      <img src="@/assets/sign_up/アセット 55@2x.png" v-if="page === 6 && Object.keys(this.hearingId).length < 15" class = "inactive_img" />
      <img src="@/assets/sign_up/アセット 55@2x.png" v-else-if="page === 6" @click="pushedComplete" />
    </div>
    <Dialog v-show="showContent" @pushedCancel="hideContent" @handle-submit="submit" />
  </div>
</template>

<script>
import moment from "moment";
import Header from "@/components/Header";
import Navigation from "@/components/Navigation";
import Dialog from "@/components/ShowDialog";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const UserRepository = RepositoryFactory.get("user");
const HearingsRepository = RepositoryFactory.get("hearings");
export default {
  name: "FrailtyRiskCheck",
  components: {
    Header,
    Navigation,
    Dialog,
  },
  data() {
    return {
      yes: 1,
      no: 0,
      page: 1,
      decimalPoint: 1,
      hearingId: {},
      hearings: {
        height: 150,
        weight: 50,
        stretch: 1,
        hearing_check: {},
        date: moment().format("YYYY-MM-DD"),
      },
      showContent: false,
    };
  },
  created() {
    // アクセストークンが有効期限きれかどうか判定する
    this.RefreshTokenUpdate()
  },
  async mounted() {
    
    const part = "items";
    await HearingsRepository.get(part, this.$store.state.axiosHeaders)
      .then((response) => (this.hearings.hearing_check = response.data))
      .catch((error) => console.log(error));
    this.index = 0;
    for (const items in this.hearings.hearing_check) {
      this.$set(this.hearings.hearing_check[items], "Number", Math.floor(this.index / 3));
      this.index = this.index + 1;
    }
  },
  methods: {
    async RefreshTokenUpdate(){
      this.$store.state.axiosHeaders.access_token_expires_in = 1614566933; //有効期限切れトークン　検証時にコメントアウト外す
      // users.access_token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJsYXNoaWMiLCJleHAiOjE2NDA4NzY0MDAsInVzZXJfaWQiOiI3Nzc3In0.vzDNjvjXiM8f41xSU48-zI7VYEPXPbOpVlENvuHaWgg"
      let access_token_expires_in = new Date(this.$store.state.axiosHeaders.access_token_expires_in * 1000);
      let now = new Date();

      if (now > access_token_expires_in) {
        const UserEndpoint = "token/refresh";
        const body = {
          refresh_token: this.$store.state.axiosHeaders.refresh_token,
        };
        const config = {
          withCredentials: true,
        };
        await UserRepository.put(UserEndpoint, body, {config})
        .then(response => (this.res = response.data))
        .catch((error) => console.log(error))
        .finally(() => {
          const headers = {
            Authorization: "Bearer " + this.res.access_token,
            "Ocp-Apim-Subscription-Key": process.env.SUBSCRIPTION_KEY,
            access_token_expires_in: this.res.access_token_expires_in,
            refresh_token: this.res.refresh_token
            }
            this.$store.commit("FETCH_ADD_AXIOS_HEADERS", headers);
        })
      }
    },
    next() {
      this.page++;
      if (this.page === 2) this.$refs.child.frailtyRiskCheck();
    },
    prev() {
      this.page--;
      if (this.page === 1) this.$refs.child.basicDataEntry();
    },
    pushedComplete() {
      this.showContent = true;
    },
    hideContent() {
      this.showContent = false;
    },
    // ヒアリング情報登録を行う
    async submit() {
      const body = {
        "height" : this.hearings.height,
        "weight" : this.hearings.weight + ((this.decimalPoint - 1) / 10),
        "stretch" : this.hearings.stretch - 1,
        "hearing_check" : this.hearingId,
        "date" : this.hearings.date,
      };
      await HearingsRepository.post(body, this.$store.state.axiosHeaders)
        .then(response => console.log(response.data))
        .catch((error) => console.log(error))
        .finally(() => {
          this.$store.commit("FETCH_SET_TUTORIAL", false)
          this.$router.push("/home")
        });
    },
  },
};
</script>

<style scoped>
@import "../assets/css/frailty_risk_check.css";
</style>



// WEBPACK FOOTER //
// src/pages/FrailtyRiskCheck.vue